// extracted by mini-css-extract-plugin
export default {"base":"ControlBox_base__dVlA8","fit":"ControlBox_fit__0Vs0I","shadow":"ControlBox_shadow__OIZws"};